import { render, staticRenderFns } from "./bankinfo-info.vue?vue&type=template&id=d2b3a186&scoped=true&"
import script from "./bankinfo-info.vue?vue&type=script&lang=js&"
export * from "./bankinfo-info.vue?vue&type=script&lang=js&"
import style0 from "./bankinfo-info.vue?vue&type=style&index=0&id=d2b3a186&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b3a186",
  null
  
)

component.options.__file = "bankinfo-info.vue"
export default component.exports